module.exports = __webpack_public_path__ + "static/media/estimator.c79a01d7.png";